import repository from "@/repository";
import FormularioUtil from "@/includes/util/FormularioUtil";
import FormularioValidator from "@/includes/validation/FormularioValidator";

const validator = new FormularioValidator()

export const actions = {
    obterFormularioSalvo: (context, email) => new Promise((resolve, reject) => {
        repository.obterFormularioPorEmail(email)
            .then(({id, formularioFromRepository}) => {
                context.commit('setFormulariosId', id)
                context.commit('setFormularioPerfil', context.state.formulario.perfil.fields.map(localField => {
                    const fieldFounded = formularioFromRepository.perfil.fields.find(f => f.label === localField.label);
                    if (fieldFounded) {
                        localField.setValue(fieldFounded.value)
                    }
                    return localField
                }))
                // context.commit('setFormularioImpacto', formularioFromRepository.impacto)
                context.commit('setFormularioImpacto', context.state.formulario.impacto.fields.map(localField => {
                    const fieldFounded = formularioFromRepository.impacto.fields.find(f => f.label === localField.label);
                    if (fieldFounded) {
                        localField.setValue(fieldFounded.value)
                    }
                    return localField
                }))
                // context.commit('setFormularioImpactoEconomico', formularioFromRepository.impactoEconomico)
                context.commit('setFormularioImpactoEconomico', context.state.formulario.impactoEconomico.fields.map(localField => {
                    const fieldFounded = formularioFromRepository.impactoEconomico.fields.find(f => f.label === localField.label);
                    if (fieldFounded) {
                        localField.setValue(fieldFounded.value)
                    }
                    return localField
                }))
                // context.commit('setFormularioFinal', formularioFromRepository.final)
                context.commit('setFormularioFinal', context.state.formulario.final.fields.map(localField => {
                    const fieldFounded = formularioFromRepository.final.fields.find(f => f.label === localField.label);
                    if (fieldFounded) {
                        localField.setValue(fieldFounded.value)
                    }
                    return localField
                }))
            })
            .catch(error => reject(error))
    }),
    salvarFormularioPerfil: ({commit}, fields) => {
        const validationErrors = validator.setTargerForValidation(fields).isValid()
        if (validationErrors.any()) {
            return Promise.reject(validationErrors)
        }
        commit('setFormularioPerfil', fields)
        return Promise.resolve()
    },
    salvarFormularioImpacto: ({commit}, fields) => {
        const validationErrors = validator.setTargerForValidation(fields).isValid()
        if (validationErrors.any()) {
            return Promise.reject(validationErrors)
        }
        commit('setFormularioImpacto', fields)
        return Promise.resolve()
    },
    salvarFormularioImpactoEconomico: ({commit}, fields) => {
        const validationErrors = validator.setTargerForValidation(fields).isValid()
        if (validationErrors.any()) {
            return Promise.reject(validationErrors)
        }
        commit('setFormularioImpactoEconomico', fields)
        return Promise.resolve()
    },
    salvarFormularioFinal: ({commit}, fields) => {
        const validationErrors = validator.setTargerForValidation(fields).isValid()
        if (validationErrors.any()) {
            return Promise.reject(validationErrors)
        }
        commit('setFormularioFinal', fields)
        return Promise.resolve()
    },
    salvarFormularios: ({state, commit}) => new Promise((resolve, reject) => {
        const formulario = {
            perfil: FormularioUtil.formatToJSON(state.formulario.perfil),
            impacto: FormularioUtil.formatToJSON(state.formulario.impacto),
            impactoEconomico: FormularioUtil.formatToJSON(state.formulario.impactoEconomico),
            final: FormularioUtil.formatToJSON(state.formulario.final)
        }
        if (!state.formularioId) {
            repository.salvarFormulario(formulario)
                .then(() => {
                    commit('clearAll')
                    resolve()
                })
                .catch(error => reject(error))
        } else {
            repository.salvarFormulario(formulario)
                .then(() => resolve())
                .catch(error => reject(error))
        }
    }),
    criarNovoUsuario: (context, autenticacao) => new Promise((resolve, reject) => {
        repository.criarNovoUsuario(autenticacao.email, autenticacao.password)
            .then(user => {
                context.commit('setUsuario', user)
                resolve(user)
            })
            .catch(error => reject(error))
    }),
    resetarSenha: (context, email) => new Promise((resolve, reject) => {
        repository.resetarSenha(email)
            .then(() => resolve())
            .catch(error => reject(error))
    }),
    autenticarUsuario: (context, autenticacao) => new Promise((resolve, reject) => {
        repository.autenticarUsuario(autenticacao.email, autenticacao.password)
            .then(user => {
                console.log(user)
                context.commit('setUsuario', user)
                resolve(user)
            })
            .catch(error => reject(error))
    }),
    logout: async (context) => {
        await repository.logout()
        context.commit('logout')
        context.commit('clearAll')
    }
};